import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({ standalone: false,
  selector: 'app-logo',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './logo.component.html'
})
export class LogoComponent { 
  readonly logoType = input<number>(0);

  get logoSource(){
    switch(this.logoType()){
      case 0:{
        return '../assets/images/logos/fa-logo.png';
      }
      case 1:{
        return '../assets/images/logos/fa-logo-white.png';
      }
      case 2:{
        return '../assets/images/logos/fa-icon.png';
      }
      default:{
        return '../assets/images/logos/fa-logo.png';
      }
    }
  }
}
